/* src/app/import/import-presenter/import-presenter.component.scss */
li {
  padding: 1rem;
}
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-top: 0.5rem;
}
body#themeTag :host ::ng-deep .p-message.p-message-info {
  margin: 0 !important;
}
/*# sourceMappingURL=import-presenter.component.css.map */
